import React, { useState } from "react"
import { View, StyleSheet } from "react-native"
import { useTheme } from "react-native-paper"
import { TableBase } from "./TableBase"
import { ExpandedTable } from "./ExpandedTable"
import type { TableProps } from "../../types/table"

export const Table: React.FC<TableProps> = ({ OnExpandedButtonClick, menuAction, ...props }) => {
    const theme = useTheme()
    const [isExpanded, setIsExpanded] = useState(false)

    const handleExpandButtonClick = () => {
        setIsExpanded(true)
    }

    return (
        <View style={styles.container}>
            <TableBase
                {...props}
                OnExpandedButtonClick={handleExpandButtonClick}
                menuAction={menuAction} />
            {!OnExpandedButtonClick && (
                <ExpandedTable
                    {...props}
                    visible={isExpanded}
                    onDismiss={() => setIsExpanded(false)}
                />
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    }
})
